import React, { Component } from "react";
import {Link, withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import {FormattedMessage} from 'react-intl'
import HtmlSection from './htmlsection';
import * as wConsts from '../consts/website-consts';
import BuyAdBanner from "./buyadbanner";
import SeoHeaders from "./seoheaders";
import * as wActs from "../actions/website-actions";
import SwBanner from "./swbanner";
import SsrBanner from "./ssrbanner";

class Footer extends Component {

  handleClick(e) {
    eval('$("html, body").animate({scrollTop: "0px"}, 800)');
    //return true;
  }

  getRequestInfo() {
    if(this.props.WebPage.Request) {
      let req = this.props.WebPage.Request;
      return (<span>{req.IpAddress} - [{req.CountryCode}]</span>)
    } else {
      return null;
    }
  }


  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  handleRefresh(e) {
    e.preventDefault();
    window.location.reload(true) //Force cache update fuckers
  }

  render() {
    let tmp = this.props.WebPage.Page.Template;
    let acc = "NL";
    if(!wActs.isNullOrUndefined(tmp)) {
      if(!wActs.isNullOrUndefined(tmp.Country) && !wActs.isNullOrEmpty(tmp.Country.Code)) {
        acc=tmp.Country.Code;
      }
    }
    let isHome = this.props.WebPage.Page.Template.Name == "Links" || this.props.WebPage.Page.Template.Name == "Home";
    return (
      <React.Fragment>

        <footer className="footer">
          <div className="container text-center" style={{margin: "40px auto"}}>
            <div id={"link-exchg"}>{this.getTranslation("page.links.areyouinterestedinabannerorlinkexchangewithus").replace("{{SiteName}}",this.props.WebPage.Settings.SiteName)}&nbsp;-&nbsp;<Link to={wActs.getCultPath(this.props.WebPage,"/links")}>{this.getTranslation("page.links.linkexchange")}</Link></div>
          </div>
          <div className="container">
            <div className="banner-row flex">
              <SsrBanner AdsHereCount={1}  IsHome={isHome} ZoneId="home-200x100" apiAnonId={this.props.WebPage.Request.AnonymousId} CountryCode={acc} className={"newbottom-bbanners"}>
                <BuyAdBanner size={"200x100"} textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")} hideBottom={true}/>
              </SsrBanner>
            </div>
          </div>

          <div style={{display: "flex", justifyContent: "center", margin: "40px auto"}}><HtmlSection Id={"DMCA"}/></div>
          <HtmlSection Id={"Onesignal"}/>
        </footer>


      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    HtmlSections: state.Website.Settings.HtmlSections
  };
}

export default connect(mapStateToProps)(Footer);
